import { useMutation, useQueryClient } from 'react-query';
import axios from 'axios';
import { RatingAPI } from '../../../constants/API';
import { commonHeaders } from '../../../constants/HeadersAPI';

export const usePostRatingMedia = (branchQueueId: number | null) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ file, purpose }: { file: File; purpose: 'BACKGROUND' | 'SCREENSAVER' }) => {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('purpose', purpose);
      return axios.post(RatingAPI.uploadMedia(branchQueueId!), formData, {
        ...commonHeaders(),
        headers: {
          ...commonHeaders().headers,
          'Content-Type': 'multipart/form-data'
        }
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['ratingSettings', branchQueueId]);
      }
    }
  );
};
